import React, { Component } from 'react';
import Footer from '../../components/Footer';
import Mainmenu from '../../components/Mainmenu';
import Navbar from '../../components/Navbar';
import RatingsSelectorContent from './RatingsSelectorContent';

export default class RatingsSelector extends Component {
    render() {
        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <RatingsSelectorContent />
                <Footer />
            </div>
        );
    }
}
